// Status badges for HR documents (payroll, payslip, claim), per docs/UI-GUIDELINES.md section 3.3.
// CoreUI colours: guideline "error" -> "danger", "grey" -> "secondary".
// Keys are the backend enum names; numeric enum values are accepted too.

const MAPS = {
  // PayrollStatus: Draft=0, Approve=1, Paid=2, Cancelled=3
  payroll: {
    order: ["Draft", "Approve", "Paid", "Cancelled"],
    map: {
      Draft: { color: "secondary", label: "Draft" },
      Approve: { color: "primary", label: "Approved" },
      Paid: { color: "success", label: "Paid" },
      Cancelled: { color: "secondary", label: "Cancelled" },
    },
  },
  // PaySlipStatus: Draft, Approve, Sent, Paid, UnPaid, Cancelled
  payslip: {
    order: ["Draft", "Approve", "Sent", "Paid", "UnPaid", "Cancelled"],
    map: {
      Draft: { color: "secondary", label: "Draft" },
      Approve: { color: "primary", label: "Approved" },
      Sent: { color: "info", label: "Sent" },
      Paid: { color: "success", label: "Paid" },
      UnPaid: { color: "warning", label: "Unpaid" },
      Cancelled: { color: "secondary", label: "Cancelled" },
    },
  },
  // ClaimState: Draft=0, Submit=1, Approve=2, Paid=3, Cancelled=4, NotApprove=5
  claim: {
    order: ["Draft", "Submit", "Approve", "Paid", "Cancelled", "NotApprove"],
    map: {
      Draft: { color: "secondary", label: "Draft" },
      Submit: { color: "warning", label: "Submitted" },
      Approve: { color: "primary", label: "Approved" },
      NotApprove: { color: "danger", label: "Not approved" },
      Paid: { color: "success", label: "Paid" },
      Cancelled: { color: "secondary", label: "Cancelled" },
    },
  },
};

function resolve(type, status) {
  const def = MAPS[type];
  if (!def || status === null || status === undefined || status === "") return null;
  const key = typeof status === "number" ? def.order[status] : String(status);
  return def.map[key] || null;
}

/** CoreUI badge colour for an HR status. */
export function hrStatusColor(type, status) {
  const entry = resolve(type, status);
  return entry ? entry.color : "secondary";
}

/** Human, sentence-case label for an HR status. Never returns a raw enum name for known statuses. */
export function hrStatusLabel(type, status) {
  const entry = resolve(type, status);
  if (entry) return entry.label;
  if (status === null || status === undefined || status === "") return "";
  // Unknown value: split camel case into words, sentence case.
  const words = String(status).replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** Options for a status filter select: [{ value: enumName, label }]. */
export function hrStatusOptions(type, allLabel = "All statuses") {
  const def = MAPS[type];
  return [{ value: "", label: allLabel }].concat(
    def.order.map((key) => ({ value: key, label: def.map[key].label }))
  );
}

/** Vue mixin: `hrStatusColor` / `hrStatusLabel` available in templates. */
export const hrStatusMixin = {
  methods: {
    hrStatusColor,
    hrStatusLabel,
  },
};
